import React from "react";

import { ReactMarques } from "react-marques";
import pic1 from "../assets2/carousel1.png";
import pic2 from "../assets2/carousel2.png";
// import pic3 from "../assets2/carousel3.png";
import pic4 from "../assets2/carousel5.jpg";
import pic10 from "../assets2/carousel10.jpg";
import pic11 from "../assets2/carousel11.png";
import pic12 from "../assets2/carousel12.jpg";

const Home = () => {
  return (
    <>
      <div className="hero border-1 pb-3">
        <div className="card bg-dark text-white border-0 mx-3">
          {/* <img
            className="card-img img-fluid"
            src="./assets/banner.png"
            alt="Card"
            height={200}
          /> */}
          <ReactMarques fade={true} style={{ width: "100%", backgroundColor: 'white' }}>
            <img src={pic1} alt="ai" />
            <img src={pic4} alt="ai" />
            <img src={pic10} alt="ai" />
            <img src={pic2} alt="ai" />
            <img src={pic11} alt="ai" />
            <img src={pic12} alt="ai" />
          </ReactMarques>
          {/* <div className="card-img-overlay d-flex align-items-center">
            <div className="container">
              <h5 className="card-title fs-1 text fw-lighter">New Season Arrivals</h5>
              <p className="card-text fs-5 d-none d-sm-block ">
                This is a wider card with supporting text below as a natural
                lead-in to additional content. This content is a little bit
                longer.
              </p>
            </div>
          </div> */}
        </div>
      </div>
    </>
  );
};

export default Home;
